import {
  HIDE_REMOTE_REMINDER_DIALOG,
  SHOW_REMOTE_REMINDER_DIALOG,
} from "./reminder.actions";

const initial = {
  showRemoteReminderDialog: false,
};

export const reducer = (state = initial, action) => {
  switch (action.type) {
    case SHOW_REMOTE_REMINDER_DIALOG: {
      return {
        ...state,
        showRemoteReminderDialog: true,
      };
    }
    case HIDE_REMOTE_REMINDER_DIALOG: {
      return {
        ...state,
        showRemoteReminderDialog: false,
      };
    }
    default:
      return state;
  }
};
